import React from "react";
import CustomTable from "../../components/CustomTable";
import { getPerformanceVenues } from "../../../services/CommonServices";

const PerformanceVenues = () => {
  const columns = [
    {
      label: "#",
      key: "performancevenue_code",
      render: (row, index, currentPage = 1, pageSize = 10) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Stage",
      key: "title",
      render: (row) => (
        <span className="fw-semibold">{row?.title ?? "-"}</span>
      ),
    },
    {
      label: "Venue",
      render: (row) => {
        console.log("svnhiosevse", row);
        return (
          <span>{`${row?.venue_id?.title}, ${row?.venue_id?.city?.name}`}</span>
        );
      },
    },
    {
      label: "Capacity",
      key: "capacity",
    },
    {
      label: "Entries",
      key: "entries",
    },
  ];
  return (
    <CustomTable
      title="Stages"
      addBtnTitle="Create New Stage"
      columns={columns}
      getHook={getPerformanceVenues}
      store={"performanceVenue"}
      deleteHook="performanceVenue"
    />
  );
};

export default PerformanceVenues;
